import React, { useState, useEffect, useMemo } from 'react';
import { Row, Col } from 'antd';
import dayjs from 'dayjs';
import { useCommonStore } from '@/store/useCommonStore';

// 导入组件
import WelcomeSection from './components/WelcomeSection';
import StatisticsCards from './components/StatisticsCards';
import TodoList from './components/TodoList';
import GitActivityChart from './components/GitActivityChart';
import TaskCalendar from './components/TaskCalendar';
import ProjectOverview from './components/ProjectOverview';
import YearProgressClock from './components/YearProgressClock';

// 模拟数据 - 实际项目中应从API获取
const mockData = {
  user: {
    name: '张三',
    avatar: 'https://api.dicebear.com/7.x/miniavs/svg?seed=1',
    department: '技术部',
    position: '高级开发工程师'
  },
  todos: [
    { id: 1, title: '完成用户管理模块代码审查', priority: 'high', deadline: '2024-01-15', status: 'pending' },
    { id: 2, title: '修复流程编辑器拖拽bug', priority: 'medium', deadline: '2024-01-16', status: 'pending' },
    { id: 3, title: '编写API文档', priority: 'low', deadline: '2024-01-18', status: 'pending' },
    { id: 4, title: '参加项目评审会议', priority: 'high', deadline: '2024-01-15', status: 'completed' }
  ],
  projects: {
    owned: 3,
    participated: 8,
    completed: 12
  },
  workload: {
    thisWeek: 32,
    lastWeek: 28,
    target: 40
  },
  gitActivity: (() => {
    const activity = [];
    const today = dayjs();
    // 生成过去12周的数据
    for (let week = 11; week >= 0; week--) {
      for (let day = 0; day < 7; day++) {
        // 计算日期：从今天往前推week周，然后调整到周一，再加上day天
        const weekStart = today.subtract(week, 'weeks');
        const dayOfWeek = weekStart.day(); // 0=周日, 1=周一, ..., 6=周六
        const mondayOfWeek = weekStart.subtract(dayOfWeek === 0 ? 6 : dayOfWeek - 1, 'days');
        const date = mondayOfWeek.add(day, 'days');
        const commits = Math.floor(Math.random() * 10); // 随机生成0-9次提交
        activity.push({
          date: date.format('YYYY-MM-DD'),
          commits,
          dayOfWeek: day,
          weekOfYear: week
        });
      }
    }
    return activity;
  })(),
  calendar: [
    { date: '2024-01-15', type: 'meeting', title: '项目评审会议' },
    { date: '2024-01-16', type: 'deadline', title: '功能开发截止' },
    { date: '2024-01-18', type: 'review', title: '代码审查' }
  ]
};

function Home() {
  const [selectedDate, setSelectedDate] = useState(dayjs());
  
  // 待办事项统计
  const todoStats = useMemo(() => {
    const pending = mockData.todos.filter(todo => todo.status === 'pending');
    const high = pending.filter(todo => todo.priority === 'high').length;
    const medium = pending.filter(todo => todo.priority === 'medium').length;
    const low = pending.filter(todo => todo.priority === 'low').length;
    return { total: pending.length, high, medium, low };
  }, []);

  const handleDateSelect = (date) => {
    setSelectedDate(date);
  };

  return (
    <div className="wsc-layout-bg p-6 h-[calc(100vh-6.3rem)] overflow-y-auto">
      {/* 欢迎区域 */}
      <WelcomeSection user={mockData.user} />
      
      <div className="flex flex-wrap gap-6 mb-6">
        {/* 年度进度与时钟 */}
        <div className="w-full lg:w-1/4">
          <YearProgressClock />
        </div>
        
        {/* 统计卡片 */}
        <div className="w-full lg:w-[calc(75%-1.5rem)]">
          <StatisticsCards 
            todoStats={todoStats}
            projects={mockData.projects}
            workload={mockData.workload}
            todos={mockData.todos}
          />
        </div>
      </div>

      {/* 主要内容区域 */}
      <Row gutter={[16, 16]}>
        {/* 左侧列 */}
        <Col xs={24} lg={12}>
          {/* 待办事项 */}
          <TodoList todos={mockData.todos} />

          {/* Git提交活动 */}
          <GitActivityChart gitActivity={mockData.gitActivity} />
        </Col>

        {/* 右侧列 */}
        <Col xs={24} lg={12}>
          {/* 任务日历 */}
          <TaskCalendar 
            calendar={mockData.calendar}
            selectedDate={selectedDate}
            onDateSelect={handleDateSelect}
          />

          {/* 项目概览 */}
          <ProjectOverview projects={mockData.projects} />
        </Col>
      </Row>
    </div>
  );
}

export default Home;
